import axios from "axios";

export default function sendTgErrors(errors){
  axios.post('/debug', {
    "message": JSON.stringify(errors),
  })
}
